import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepper = ["職員選択/配置換え入力", "配置換え確認", "登録完了"];

const fakeTableList: (ITkFakeTableLineProps & {
  businessType?: string;
  buttonName?: string;
  disabled?: boolean;
  path?: string;
})[] = [
  {
    contractorName: "契約者（法人）名",
    keyword: "contractorName",
    type: "contractorAndNumber",
  },
  {
    keyword: "title",
    type: "lineTitle",
    lineTitle: "1,施設情報の登録",
  },
  {
    title: "廃止・休止した施設・事業の登録",
    keyword: "discontinuedOrSuspended",
    type: "nodeInLine",
    businessType: "JOB-18",
    buttonName: "廃止・休止の手続きをする",
    path: "/SCRC050120",
  },
  {
    title: "施設・事業の名称・所在地の変更の登録",
    keyword: "facilitiesBusinesses",
    type: "nodeInLine",
    businessType: "JOB-19",
    buttonName: "名称・所在地を変更する",
    path: "/SCRC050017",
  },
  {
    title: "特定職員数又は措置入所障害児職員数の訂正",
    keyword: "numberOfStaff",
    type: "nodeInLine",
    buttonName: "特定職員数又は措置入所障害児職員数を修正する",
    disabled: true,
    path: "/SCRC050029",
  },
  {
    keyword: "title",
    type: "lineTitle",
    lineTitle: "2,職員情報の登録",
  },
  {
    title: "従業情報を更新",
    keyword: "employeeInfoUpdate",
    type: "nodeInLine",
    businessType: "JOB-25",
    buttonName: "従業情報を更新する",
    path: "/SCRW060101",
  },
  {
    title: "新規加入者の登録",
    keyword: "registrationOfNewSubscribers",
    type: "nodeInLine",
    businessType: "JOB-23",
    buttonName: "職員を登録する",
    path: "/SCRC060108",
  },
  {
    title: "配置換え情報の登録",
    keyword: "registrationOfReallocationInfo",
    type: "nodeInLine",
    businessType: "JOB-27",
    buttonName: "配置換え手続きをする",
    path: "/SCRC060103",
  },
  {
    title: "本俸月額の登録",
    keyword: "registrationOfMonthlySalary",
    type: "nodeInLine",
    businessType: "JOB-26",
    buttonName: "俸給の更新をする",
    path: "/SCRC060116",
  },
];

export { stepper, fakeTableList };
